/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youtube_Export_Privacy_PrivateInputs */

const cs_youtube_export_privacy_private = /** @type {(inputs: Youtube_Export_Privacy_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soukromé`)
};

const en_youtube_export_privacy_private = /** @type {(inputs: Youtube_Export_Privacy_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private`)
};

/**
* | output |
* | --- |
* | "Private" |
*
* @param {Youtube_Export_Privacy_PrivateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const youtube_export_privacy_private = /** @type {((inputs?: Youtube_Export_Privacy_PrivateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youtube_Export_Privacy_PrivateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youtube_export_privacy_private(inputs)
	return cs_youtube_export_privacy_private(inputs)
});